import React, { useEffect, useState } from "react";
import DashboardIcon from "../../image/DashboardIcon.svg";
import logo from "../../image/smartbuyerLogo.png";
import newLogo from "../../image/PROCEM3.svg";
import collapsed_logo from "../../image/SmartbuyerFeviconicon.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Layout, Steps } from "antd";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  RightOutlined,
  LogoutOutlined,
  UserOutlined,
  SolutionOutlined,
  SettingOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import { Button } from "antd";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";

const { Sider } = Layout;

const StepSider = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [current, setCurrent] = useState(0);
  const [steps, setSteps] = useState([
    {
      title: "Material Master",
      path: "/material-master-step",
      completed: false,
    },
    {
      title: "Site Location",
      path: "/site-location-step",
      completed: false,
    },
    {
      title: "Manage User Group",
      path: "/user-manage-group-step",
      completed: false,
    },
    {
      title: "Manage User",
      path: "/manage-user-step",
      completed: false,
    },
    {
      title: "PR Release Hierarchy",
      path: "/pr-release-hierarchy-step",
      completed: false,
    },
    {
      title: "Business Setting",
      path: "/business-setting-step",
      completed: false,
    },
    {
      title: "Vendor Onboarding",
      path: "/vendor-onboarding-step",
      completed: false,
    },
  ]);

  useEffect(() => {
    const currentPath = location.pathname.split("/")[1];
    // console.log(location.pathname.split("/")[1], "pathname");
    // console.log(location.pathname, "pathname");
    const currentIndex = steps.findIndex(
      (step) => step.path === `/${currentPath}`
    );
    if (currentIndex !== -1) {
      setCurrent(currentIndex);
    }
  }, [location]);

  const handleStepClick = (index, path) => {
    setCurrent(index);
    navigate(path);
  };

  const handleStepComplete = (index) => {
    const updatedSteps = [...steps];
    updatedSteps[index].completed = true;
    setSteps(updatedSteps);
  };

  return (
    <>
      <section className="stepssidebar">
        <Sider
          width={330}
          breakpoint="lg"
          collapsedWidth="60px"
          collapsible
          collapsed={collapsed}
          trigger={null}
        >
          <div className="LogoSec">
            <img
              className="widhout-collapsed-logo"
              src={newLogo}
              width={"180px"}
              height={"51px"}
              alt="Smart Buyer Logo"
            ></img>
            <img
              className="with-collapsed-logo"
              src={collapsed_logo}
              width={"200px"}
              height={"36px"}
              alt="Smart Buyer Logo"
            ></img>
          </div>
          <h3>Welcome to PROCEM!</h3>
          <p>
            We’re excited to have you onboard To get started, please enter your
            details below.
          </p>

          <Steps
            current={current}
            className="menusteps"
            direction="vertical"
            items={steps.map((step, index) => ({
              title: step.title,
              className: current === index ? "active" : "",
              icon: step.completed ? <CheckCircleOutlined /> : null,
              // onClick: () => handleStepClick(index, step.path),
            }))}
          />
        </Sider>

        <Button
          type="text"
          className="toggleBtn"
          icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          onClick={() => setCollapsed(!collapsed)}
          style={{
            fontSize: "16px",
            width: 64,
            height: 64,
          }}
        />
      </section>
    </>
  );
};

export default StepSider;
